// extracted by mini-css-extract-plugin
export default {"titleBlock":"SuccessToast_titleBlock__Rg8xc","text":"SuccessToast_text__lsvTf","icon":"SuccessToast_icon__fYcIS","container":"SuccessToast_container__Un+nm"};